module.exports = __webpack_public_path__ + "media/images/dashboard/yogasix-banner-card-c68fb9b3b9f1d59ae307121ebdb587e5.jpg";